/**
 * Responsibility: Implement lobby state behavior for the ui/lobby surface.
 * Scope: Owns ui/lobby concerns only; cross-surface orchestration is excluded.
 */
export const LOBBY_SECTION_KEY = 'am2_lobby_section'
export const LOBBY_SELECTION_KEY = 'am2_lobby_selection'

export const LOBBY_STATE_ALIASES = {
  hub: 'hub',
  resume: 'saves',
  saves: 'saves',
  worlds: 'worlds',
  worldGallery: 'worlds',
  vessels: 'vessels',
  vesselGallery: 'vessels',
  start: 'pairing',
  pairing: 'pairing',
  import: 'import',
  marketplace: 'marketplace',
  forging: 'forging',
} as const

export function normalizeLobbyState(stateName: unknown): string {
  const value = String(stateName || '').trim()
  return LOBBY_STATE_ALIASES[value as keyof typeof LOBBY_STATE_ALIASES] ?? 'hub'
}

export function restoreLobbySection(): string {
  try {
    return normalizeLobbyState(sessionStorage.getItem(LOBBY_SECTION_KEY))
  } catch {
    return 'hub'
  }
}

export function persistLobbySection(section: unknown): void {
  try {
    sessionStorage.setItem(LOBBY_SECTION_KEY, normalizeLobbyState(section))
  } catch {
    // ignored
  }
}
